// export const API_BASE_URL = "http://localhost:8080"
// export const FLASK_API_BASE_URL = "http://localhost:8081"
// export const  DOWNLOAD_BASE_URL = "http://localhost:5000"


export const API_BASE_URL = "https://apis.vydeo.xyz/java"
export const FLASK_API_BASE_URL = "https://apis.vydeo.xyz/py"
export const DOWNLOAD_BASE_URL = "https://localhost:5000"
export const WebSocket_URL = "wss://apis.vydeo.xyz/ws"